<script setup>

import {useStore} from "vuex";

const store = useStore();

</script>

<template>
  <div v-if="store.state.userSettings.highlightActualDate" class="cmp-grid-mode-data-notification_mode-display">
    <div style="color: #0a0a0a; margin-right: 10px;">Date Status Indicator:</div>
    <div class="cmp-grid-mode-data-notification_actual-date-color"></div>
    <div style="font-size: 11px;">- Actual Date <span style="font-size: 10px;"> (Non Highlighted is Estimated)</span> </div>
  </div>
  <div v-else-if="store.state.userSettings.useMeasuredGrid" class="cmp-grid-mode-data-notification_mode-display">
    <div style="color: #0a0a0a">Date indicators:</div>
    <div class="cmp-grid-mode-data-notification_on-time-date-color"></div>
    <div class="cmp-grid-mode-data-notification_heading">On Schedule</div>
    <div class="cmp-grid-mode-data-notification_due-today-date-color"></div>
    <div class="cmp-grid-mode-data-notification_heading">Due Today</div>
    <div class="cmp-grid-mode-data-notification_late-date-color"></div>
    <div class="cmp-grid-mode-data-notification_heading">Overdue</div>
  </div>
</template>

<style lang="scss" scoped>

.cmp-grid-mode-data-notification {

  &_mode-display {
    display: flex;
    align-items: center;
    font-size: 12px;
    height: 16px;
    z-index: 999;
    padding: 5px 10px 5px 13px;
    //background: #f8f8f8;
  }

  &_heading {
    font-size: 11px;
  }

  &_actual-date-color {
    height: 10px;
    width: 20px;
    border-radius: 3px;
    margin: 0 6px 0 6px;
    background: var(--actual-date);
  }

  &_late-date-color {
    height: 10px;
    width: 20px;
    border-radius: 3px;
    margin: 0 5px 0 20px;
    background: var(--grid-cell-date-late);
  }

  &_due-today-date-color {
    height: 10px;
    width: 20px;
    border-radius: 3px;
    margin: 0 5px 0 20px;
    background: var(--grid-cell-date-due-today);
  }

  &_on-time-date-color {
    height: 10px;
    width: 20px;
    border-radius: 3px;
    margin: 0 5px 0 20px;
    background: var(--grid-cell-date-on-time);
  }
}

</style>
